import styled from 'styled-components';
import Link from 'next/link';
import { getStyles } from './listItemWholeLink.mixn';

export const ListItemWholeLinkContainerStyled = styled(Link)`
  ${({ theme }) => getStyles(theme)}
`;

export const ListItemWholeContainerStyled = styled.div`
  ${({ theme }) => getStyles(theme)}
`;
